import React, {useEffect, useState} from "react";
import {Col, Form, Row} from "react-bootstrap";
import {HeaderForm} from "./HeaderForm";
import styles from "./style.module.css";
import {InputText} from "./InputText";
import {ResumeButton} from "./ResumeButton";
import {useDispatch} from 'react-redux'
import {workwithus_v1_insert} from "../../../../../redux/workwithus/workwithus_v1_insert/action";
import Alert from "../../../../common/Alerts";

export default function FormResume() {

    const dispatch = useDispatch()

    const [value, setValue] = useState({file_name: ""});
    const [state, setstate] = useState({
        sender_full_name: "",
        sender_email: "",
        sender_phone: "",
        job_position: "",
        sender_cv: ""
    })
    const [statusAlert, setStatusAlert] = useState({
        status: false,
        typeAlert: "",
        textAlert: ""
    })

    useEffect(() => {
        if (statusAlert.status === true)
            setTimeout(() => handleCLodrAlert(), 6000)
    }, [statusAlert.status]);

    const handleCLodrAlert = () => {
        setStatusAlert({
            status: false,
            typeAlert: "",
            textAlert: ""
        })
        clearTimeout()
    }

    const apiSubmit = (data) => {
        const {file} = data
        let _data = {
            ...state,
            sender_cv: file ? file : '',
        }
        let obj = {};
        Object.keys(_data).forEach((element) => {
            if (_data[element]) {
                obj[element] = _data[element];
            }
        });
        if (!Object.keys(obj).length) {
            setStatusAlert({
                status: true,
                textAlert: "لطفا فیلد های مورد نظر را پر نمایید",
                typeAlert: "warning"
            })
            return
        }
        let res = {
            data: {
                ..._data
            },
        };

        workwithus_v1_insert(res)
            .then(res => {
                if (res.data.response.data._id) {
                    setValue({file_name: ""})
                    setstate({
                        sender_full_name: "",
                        sender_email: "",
                        sender_phone: "",
                        job_position: "",
                        sender_cv: ""
                    })
                    setStatusAlert({
                        status: true,
                        textAlert: "فرم مشخصات فردی شما با موفقیت ارسال شد.",
                        typeAlert: "success"
                    })
                } else {
                    setStatusAlert({
                        status: true,
                        textAlert: "متاسفانه مشکلی رخ داده است. دوباره تلاش کنید.",
                        typeAlert: "warning"
                    })
                }
            })
            .catch(() => {
                setStatusAlert({
                    status: true,
                    textAlert: "خطا در ارتباط با سرور",
                    typeAlert: "error"
                })
            });


    }

    const handelChange = (type, value) => {
        setstate(prev => ({
            ...prev,
            [type]: value
        }))
    }

    const UploadFile = (data) => {
        if (
            data.file_type === 'jpeg' ||
            data.file_type === 'pdf' ||
            data.file_type === 'jpg' ||
            data.file_type === 'png'
        ) {
            setValue(data)
        } else {
            alert("لطفا فایل را با فرمت های مشخص شده وارد بفرمایید ( jpeg , pdf , jpg , png )")
        }
    }


    return (
        <>
            {
                statusAlert.status && (
                    <Alert
                        typeAlert={statusAlert.typeAlert}
                        textAlert={statusAlert.textAlert}
                    />
                )
            }
            <Form className="text-right p-lg-3">
                <HeaderForm title={"مشخصات فردی"}/>
                <Row>
                    <Col xs={12} className="mb-3">
                        <p className={styles.label}> عنوان شغلی</p>

                        <InputText value={state.job_position} setValues={(data) => handelChange("job_position", data)}/>
                    </Col>
                    <Col xs={12} className="mb-3">
                        <p className={styles.label}>نام و نام خانوادگی</p>

                        <InputText value={state.sender_full_name}
                                   setValues={(data) => handelChange("sender_full_name", data)}/>
                    </Col>
                    <Col xs={12} className="mb-3">
                        <p className={styles.label}>تلفن همراه</p>
                        <InputText value={state.sender_phone} setValues={(data) => handelChange("sender_phone", data)}/>
                    </Col>

                </Row>
                <Row>
                    <Col xs={12} className="mb-3">
                        <p className={styles.label}>پست الکترونیک</p>
                        <InputText value={state.sender_email} setValues={(data) => handelChange("sender_email", data)}/>
                    </Col>
                </Row>
                <ResumeButton apiSubmit={apiSubmit} value={value} setValue={UploadFile}/>
            </Form>
        </>
    );
};
